<template>
  <div class="regi">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">维修登记</p>
      <div></div>
    </div>
    <div class="cenbox">
      <div class="cenli">
        <span
          ><span class="color6">业务：</span>{{ from.bizName || "--" }}</span
        >
        <span
          ><span class="color6">船名：</span> {{ from.shipName || "--" }}</span
        >
      </div>
      <div class="cenli">
        <span
          ><span class="color6">船东：</span> {{ from.shipowner || "--" }}</span
        >
        <span
          ><span class="color6">电话：</span>
          {{ from.shipownerPhone || "--" }}</span
        >
      </div>
      <div class="describe">
        <span
          ><span class="color6">故障描述：</span> {{ from.hitch || "--" }}</span
        >
      </div>
      <div class="vinpu">
        <van-field
          label-width="80"
          v-model="from.sn"
          label="设备sn："
          placeholder="请输入设备sn"
        />
        <img
          src="../../../assets/workOrder/sao.png"
          alt=""
          class="imgs"
          @click="zhao(1)"
        />
      </div>
      <div class="vinpu" @click="repair">
        <van-field
          label-width="80"
          v-model="way"
          label="维修方式："
          readonly
          right-icon="arrow-down"
        />
      </div>
      <div class="vinpu" v-if="way == '更换设备'">
        <van-field
          label-width="80"
          v-model="from.freshSn"
          label="新设备sn："
          placeholder="请输入新设备sn"
        />
        <img
          src="../../../assets/workOrder/sao.png"
          alt=""
          class="imgs"
          @click="zhao(2)"
        />
      </div>
      <div class="vinpu">
        <van-field
          label-width="80"
          v-model="from.remark"
          autosize
          type="textarea"
          label="维修备注："
          placeholder="请对维修进行备注"
        />
      </div>
      <div class="vinpu">
        <van-uploader
          v-model="urls"
          accept="image/*"
          :max-count="5"
          :after-read="afterRead"
          :before-read="beforeRead"
        />
      </div>
      <div class="bottbx">
        <div class="type1" @click="quxiao">取消</div>
        <div class="type2" @click="registerFr">登记</div>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        title="维修方式"
        show-toolbar
        value-key="value"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <erq
      v-if="scan"
      ref="qrcode"
      @ok="getResult"
      @err="geterror"
      @onclose="onclose"
    ></erq>
  </div>
</template>

<script>
import { repairgetInfo, uploadFile, register } from "@/utils/network/interface";
import erq from "./components/req";

export default {
  name: "register",
  data() {
    return {
      from: {},
      way: "维修设备",
      id: this.$route.query.id,
      urls: [],
      columns: [
        { value: "维修设备", type: 1 },
        { value: "更换设备", type: 2 },
      ],
      showPicker: false,
      scan: false,
      indexstu: null,
    };
  },
  components: {
    erq,
  },
  created() {
    this.repairgetInfoFr();
  },
  mounted() {},
  methods: {
    getResult(result) {
      console.log(result, "chengg");
      if (this.indexstu == 1) {
        this.from.sn = result;
      } else if (this.indexstu == 2) {
        this.from.freshSn = result;
      }
    },
    geterror(e) {
      console.log(e, "chengg");
    },

    repairgetInfoFr() {
      repairgetInfo({ id: this.id }).then((e) => {
        console.log(e, "详情");
        this.from = e.data;
      });
    },
    // 点击取消
    onClickBack() {
      this.$router.go(-1);
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      file.status = "uploading";
      file.message = "上传中...";
      uploadFile(formData).then((res) => {
        if (res.code == 200) {
          file.status = "done";
          file.message = "message";
          file.img = res.url;
        } else {
          file.status = "failed";
          file.message = "上传失败";
        }
      });
    },
    beforeRead(file) {
      let type =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/JPG" ||
        file.type == "image/JPEG";
      console.log(type, file.type);
      if (!type) {
        this.$toast("请上传格式正确的图片！");
        return false;
      }
      return true;
    },
    zhao(s) {
      this.indexstu = s;
      this.scan = true;
      console.log(this.urls, "zhaopian");
    },
    quxiao() {
      this.$router.go(-1);
    },
    repair() {
      this.showPicker = true;
    },
    onConfirm(value) {
      console.log(value);
      this.way = value.value;
      this.from.type = value.type;
      if (value.type == 1) {
        this.from.freshSn = "";
      }
      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false;
    },
    registerFr() {
      let img = this.urls.map((vs) => {
        return { img: vs.img };
      });
      let params = {
        id: this.from.id,
        sn: this.from.sn,
        type: this.from.type || 1,
        freshSn: this.from.freshSn,
        remark: this.from.remark,
        imgs: img,
      };
      console.log(params);
      if (
        (params.id && params.sn && params.type == 1) ||
        (params.id && params.sn && params.type == 2 && params.freshSn)
      ) {
        register(params).then((e) => {
          console.log(e);
          if (e.code == 200) {
            this.$router.go(-1);
          }
        });
      } else {
        this.$toast("请把信息填写完整");
      }
    },
    onclose() {
      this.scan = false;
    },
  },
};
</script>

<style lang="less" scoped>
.regi {
  .nav {
    display: flex;
    height: 60px;
    background-color: #3db0fc;
    align-items: center;

    .title {
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #ffffff;
      line-height: 16px;
      margin: 0 auto;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }
  .cenbox {
    width: 92%;
    background-color: #fff;
    height: calc(100vh - 180px);
    margin: 16px auto 0;
    border-radius: 6px;
    padding: 20px;
    font-size: 14px;
    color: #333;
    .color6 {
      color: #666;
    }
    .cenli {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }
    .describe {
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
      line-height: 20px;
    }
    .vinpu {
      display: flex;
      align-items: center;
      .van-cell {
        padding: 6px 0;
      }
      .imgs {
        width: 20px;
        height: 20px;
      }
    }
  }
  .bottbx {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 40px;

    .type1 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #c8c8c8;
      border: 1px solid #c8c8c8;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
      margin-right: 5px;
    }
    .type2 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #3db0fc;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
      margin-right: 5px;
    }
  }
}
</style>